import { createContext, useState, useCallback } from 'react';

export interface IVariantIdsOnPageContext {
  variantIds: string[];
  setVariantIds: (variantIds: string[]) => void;
}

export const VariantIdsOnPageContext = createContext<IVariantIdsOnPageContext>({
  variantIds: [],
  setVariantIds: () => null,
});

export const getVariantIdsContextValue: () => IVariantIdsOnPageContext = () => {
  const [variantIds, setVIds] = useState<string[]>([]);

  const setVariantIds = useCallback((variantIds: string[]) => {
    setVIds(variantIds);
  }, []);

  return { variantIds, setVariantIds };
};
